// Third party
import React from 'react';

// Utils
import { formatMessage } from '@/utils/i18n';

type AddContentButtonProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

const AddContentButton: React.FC<AddContentButtonProps> = (props: AddContentButtonProps) => {
  const { open, setOpen } = props;
  return (
    <div className="trigger-button">
      <button className={`btn btn-primary ${open ? 'opened' : ''}`} onClick={() => setOpen(!open)}>
        <i className="icon-cheveron-down" />
        <span>{open ? formatMessage('Common.Collapse') : formatMessage('Proposal.AddContent')}</span>
      </button>
    </div>
  );
};

export default AddContentButton;
